module.exports = __webpack_public_path__ + "screenshot_2.934a1b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/Guides/screenshot_2.png
// module id = 3003
// module chunks = 0